import { APIURLAUTH } from "../constans";
import apiClient from '../libs/axios';
const userdata = {
    namespaced: true,
    state: {
        userdata: {},
    },

    mutations: {
        setUserdata(state, user) {
            state.userdata = user
        },
    },

    getters: {
        getUser(state) {
            return state.userdata
        },

    },

    actions: {
        getUserdata({ commit }) {
            // Simulación de una llamada asíncrona a la API de autenticación
            return new Promise((resolve, reject) => {

                apiClient.get(`${APIURLAUTH}/userdata`)
                    .then(response => {
                        const userdata = response.data;
                        commit('setUserdata', userdata.userData);
                        resolve("Inicio de session exitoso");
                    })
                    .catch(error => {
                        console.error(error);
                        reject(error);
                    });
                // Verificación de las credenciales y obtención de los datos del usuario


            });

        },
    }
}

export default userdata;
